import { IApplicationContext } from '../../types/applicationContext';
import { makeContextModule } from '@cian/react-utils';

export const {
  Context: ApplicationContext,
  useContext: useApplicationContext,
  withContext: withApplicationContext,
} = makeContextModule<IApplicationContext>({
  contextName: 'ApplicationContext',
  defaultValue: {} as IApplicationContext,
});
